// Attendees live in the Supabase `attendees` table and are loaded on every
// AttendeesScreen mount. There is no static roster file anymore — the admin
// panel (AdminScreen → Manage Attendees) is the source of truth, with realtime
// pushing edits to every open client.
//
// This file keeps the `initials` helper because both AttendeesScreen and the
// admin panel need to render the circular monogram next to each name. The
// helper is pure UI logic; no roster data lives here.

export function initials(name) {
  return name
    .split(/[\s,]+/)
    .filter((p) => p && !/^(CAE|DC|MBA|CEO|VP|EVP|At|Large|Jr|Sr)$/i.test(p))
    .map((p) => p[0])
    .join('')
    .replace(/[^A-Za-z]/g, '')
    .slice(0, 2)
    .toUpperCase();
}
